import { Checkbox, FormControl, Tooltip } from '@mui/joy';
import { Controller } from 'react-hook-form';

import { FlexBox } from 'core/elements';
import { toFieldFocusRef } from 'core/utils/fieldFocus';
import { Color } from 'theme/enums';

import { IProps } from './CheckboxInput';

const CheckboxInputWithControllerView = ({
  control,
  error,
  name,
  defaultValue = false,
  disabled,
  label,
  onChange,
  onKeyDown,
  size,
  sx,
  endDecorator,
  disabledTooltip,
}: IProps) => {
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({ field }) => {
        const checkbox = (
          <Checkbox
            name={field.name}
            label={label}
            onKeyDown={onKeyDown}
            onChange={(e) => {
              onChange && onChange(e);
              field.onChange(e.target.checked);
            }}
            onBlur={field.onBlur}
            checked={field.value}
            size={size}
            disabled={disabled}
            sx={sx}
            slotProps={{ input: { ref: toFieldFocusRef(field.ref) } }}
          />
        );

        return (
          <FlexBox>
            <FormControl error={Boolean(error)} sx={sx}>
              {disabled && disabledTooltip ? (
                <Tooltip color={Color.WARNING} title={disabledTooltip} placement="top">
                  {checkbox}
                </Tooltip>
              ) : (
                checkbox
              )}
            </FormControl>
            {endDecorator}
          </FlexBox>
        );
      }}
    />
  );
};

export default CheckboxInputWithControllerView;
